import { useState, useEffect, useCallback } from "react";
import showAlert from "../../../server/ShowAlert";
import { Payment } from "../../../server/Payment";
import { GetCards } from "../../../server/Payment";
import PayNedarim from "./PayNedarim";
import { useDispatch } from "react-redux";
import { setPreload } from "../../../server/CartsOpen";
import SelectNumPay from "./PayNum";
import PopUp from "../../containers/PopUp";
import { useSelector } from "react-redux";

const PayPopup = ({
  closePayPopup,
  tranmode,
  SumPay,
  orderId,
  coupons = [],
  comment,
  afterDiscount = null,
}) => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [sum, _setSum] = useState(null);
  const [save, setSave] = useState(false);
  const [cardId, setCardId] = useState(null);
  const [Cards, setCards] = useState([]);
  const [ShowCards, setShowCards] = useState(true);
  const [numPaymentSelect, setNumPaymentsSelect] = useState(1);
  const [disabledClick, setDisabledClick] = useState(false);

  const CalcNumberPayments = (totalPrice) => {
    if (totalPrice >= 400) {
      return Math.floor(totalPrice / 200) < 4
        ? Math.floor(totalPrice / 200)
        : 4;
    }
    return 1;
  };
  const handleDebitTokenPayment = useCallback(
    async (token, amount, tokef) => {
      // setIsPaymentInProgress(true);
      const roundedAmount = parseFloat(amount.toFixed(2));
      if (!user) return null;
      const paymentData = {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
        phone: user.phone,
        amount: roundedAmount,
        coupons: coupons,
        saveCard: save,
        paymentDetails: {
          Token: token,
          Tokef: tokef,
          Amount: roundedAmount,
          Tashloumim: numPaymentSelect,
          ClientName: `${user.firstName} ${user.lastName}`,
          Mail: user.email,
          Phone: user.phone,
          Groupe: "",
          Avour: "",
          Zeout: user.id,
          Currency: "1",
          Comment: comment,
        },
      };

      await closePayPopup(true, token, numPaymentSelect, paymentData);
      //   setIsPaymentInProgress(false);
      //   ClosePayPopup(true, token, numPaymentSelect);
      // closePayPopup(true, token, numPaymentSelect);
    },
    [save, numPaymentSelect, coupons, comment, user, closePayPopup],
  );
  const pay = async (orderId) => {
    setDisabledClick(true);

    try {
      if (tranmode) {
        if (!cardId) {
          showAlert({
            msgTitle: "שגיאה",
            msgText: "יש לבחור כרטיס לפני תשלום",
            msgType: "error",
          });
          return;
        }

        const Card = Cards.find((x) => x.token === cardId);

        if (!Card) {
          showAlert({
            msgTitle: "שגיאה",
            msgText: "הכרטיס שנבחר לא נמצא",
            msgType: "error",
          });
          return;
        }

        await handleDebitTokenPayment(
          Card.token,
          sum || SumPay,
          Card.expiry_date,
        );
      } else {
        await Payment({
          Id: cardId,
          Sum: total,
          OrderId: orderId,
          numPay: numPaymentSelect,
        });

        dispatch(setPreload(false));
      }
    } catch (err) {
      if (err.message === "NO_CARD") {
        showAlert({
          msgTitle: "שגיאה",
          msgText: "יש לבחור כרטיס לפני תשלום",
          msgType: "error",
        });
        return;
      }
      closePayPopup(false);

      showAlert({
        msgTitle: "העסקה נכשלה",
        msgText: "אנא בדקו את פרטי הכרטיס או נסו כרטיס אחר",
        msgType: "error",
      });
    } finally {
      setDisabledClick(false);
    }
  };

  // useEffect(() => {
  //   GetCards().then((x) => setCards(x.data.cards));
  //   // if (id) {
  //   //   orderId = id.substring(5, id.length - 5);
  //   //   GetPaymentPerOrder(orderId)
  //   //     .then((x) => {
  //   //       setSum(x.data.sum);
  //   //       setMassage("");
  //   //     })
  //   //     .catch((err) => setMassage(err.Message));
  //   // } else {
  //   setMassage("");
  //   // }
  // }, []);
  useEffect(() => {
    GetCards()
      .then((x) => {
        setCards(x.data.cards);
      })
      .catch((err) => console.error("GetCards error:", err));
  }, []);

  const total = Math.abs(
    Number(parseFloat(sum || afterDiscount || SumPay || 0).toFixed(2)),
  );
  const numPayments = CalcNumberPayments(total);
  const msg = " הסכום לתשלום הוא: ";
  return (
    <PopUp width="800px" close={() => closePayPopup(false)}>
      <div className="pay-popup">
        <div className="sum-to-pay">{tranmode ? msg + total + " ₪" : null}</div>

        {/* <p className="message">{message}</p> */}

        {numPayments > 1 ? (
          <p className="note"> שימו לב: לא ניתן לשלם תשלומים בכרטיס דיירקט!</p>
        ) : null}
        {ShowCards && Cards.length ? (
          <div className="use-saved-card">
            ניתן לבחור כרטיס ששמור במערכת
            {Cards.map((x) => (
              <div key={x.token}>
                <input
                  type="radio"
                  name="savedCard"
                  checked={cardId === x.token}
                  onChange={() => setCardId(x.token)}
                />
                **** {x.last_four_digits}
              </div>
            ))}
            {cardId ? (
              <div>
                {numPayments ? (
                  <SelectNumPay
                    numPayment={numPaymentSelect}
                    setNumPayment={setNumPaymentsSelect}
                    numPayments={numPayments}
                  />
                ) : null}
                {!numPayments || numPaymentSelect ? (
                  <button
                    className="btn"
                    disabled={disabledClick}
                    onClick={() => pay(orderId)}
                  >
                    אישור תשלום{" "}
                  </button>
                ) : null}
              </div>
            ) : null}
            <button className="btn" onClick={() => setShowCards(false)}>
              {" "}
              ברצוני להשתמש בכרטיס אחר
            </button>
          </div>
        ) : (
          <>
            <span className="save-card">
              {tranmode && numPayments ? (
                <SelectNumPay
                  numPayment={numPaymentSelect}
                  setNumPayment={setNumPaymentsSelect}
                  numPayments={numPayments}
                />
              ) : null}
              <p>האם ברצונך לשמור את פרטי האשראי במערכת להזמנות הבאות?</p>
              <span className="save-card-checkbox">
                <div className="checkbox-style">
                  <label> כן </label>
                  <input
                    type="radio"
                    name="saveCard"
                    checked={save === true}
                    onChange={() => setSave(true)}
                  />
                </div>
                <div className="checkbox-style">
                  <label> לא </label>
                  <input
                    type="radio"
                    name="saveCard"
                    checked={save === false}
                    onChange={() => setSave(false)}
                  />
                </div>
              </span>
              <br />
            </span>
            {save !== null && (
              <PayNedarim
                numPayments={numPayments}
                numPaymentSelect={numPaymentSelect}
                orderIdInNedarim={orderId}
                total={total}
                save={save}
                tranmode={tranmode}
                ClosePayPopup={closePayPopup}
                pay={pay}
                handleDebitTokenPayment={handleDebitTokenPayment}
              />
            )}
          </>
        )}
      </div>
    </PopUp>
  );
};

export default PayPopup;
